// components/layout/Row.jsx
import React from "react";
import { colors, space, radius, borders } from "../../design/tokens";

// export default function Row({ children, flex, gap = space.md }) {
//   const cols = React.Children.toArray(children);

//   return (
//     <div style={{ display: "flex", flexDirection: "row", gap }}>
//       {cols.map((col, i) => (
//         <div key={i} style={{ flex: flex ? flex[i] : 1 }}>
//           {col}
//         </div>
//       ))}
//     </div>
//   );
// }

// // components/layout/Row.jsx

export default function Row({ children, flex, style }) {
  const cols = React.Children.toArray(children);

  return (
    <div style={{ display: "flex", flexDirection: "row", columnGap: "5px", ...style }}>
      {cols.map((col, i) => (
        <div key={i} style={{
        ...(flex ? { flex: flex[i] } : {}),
        lineHeight: "1",
        }}>
          {col}
        </div>
      ))}
    </div>
  );
}